import './AnimatedEmoji.sass';

import React, { FC } from 'react';
import { LargeEmoji } from '$assets/mapping';
import { LottieIcon } from '$uikit';
import { AnimatedEmojiProps } from '$uikit/AnimatedEmoji/AnimatedEmoji.interface';

export const AnimatedEmoji: FC<AnimatedEmojiProps> = ({
  emoji,
  loop = false,
  size = 112,
}) => {
  const path = LargeEmoji[emoji];
  return path ? (
    <LottieIcon
      name={`https://cdn2.ton.place/emoji/largeEmoji/${path}.json`}
      size={size}
      width={size}
      height={size}
      fallback={
        <img
          src={`https://cdn2.ton.place/emoji/largeEmoji/${path}.png`}
          className="AnimatedEmoji__fallback"
          alt={emoji}
        />
      }
      loop={loop}
      className="AnimatedEmoji"
    />
  ) : null;
};
